import Stop from './Stop/Stop';
import { types } from './types';
function Actions (action, showAlert, variables, setOpenVariable, automId, variableRender) {
  if (action.actionName === types.STOP)
    return <Stop action={action} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} automId={automId} />;
}
export default Actions;